module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-Bold.791db10.eot";